import PropTypes from 'prop-types'
import React from 'react'
import { DraggableCore } from 'react-draggable'
import { connect } from 'react-redux'
import {
  compose,
  withHandlers,
  withProps,
  setPropTypes
} from 'recompose'
import { moveSection, setSectionHeight, createSection } from '../../../store/actions/sections'
import {
  sectionLayoutAdjustedSelector,
  colWidthSelector
} from '../../../store/selectors/boardSelectors'
import Section, { SectionResize } from './Section'
import { editModeSelector } from '../../../store/selectors/selectors'
import { withTranslation } from 'react-i18next'

const resizeSection = compose(
  withProps(({ section, colWidth }) => ({
    height: Math.max(section.height, section.minHeight) * colWidth
  })),
  withHandlers({
    drag: ({ section, colWidth, setSectionHeight }) => (event, data) => {
      // don't bother if no movement
      if (data.deltaY === 0) return

      const heightCols =
        (Math.max(section.unsnappedHeight, section.minHeight) * colWidth +
          data.deltaY) /
        colWidth
      setSectionHeight(heightCols)
    }
  })
)

const enhance = compose(
  connect(
    (state, { sectionId }) => ({
      section: sectionLayoutAdjustedSelector(state).get(sectionId),
      colWidth: colWidthSelector(state),
      editMode: editModeSelector(state)
    }),
    { setSectionHeight, moveSection, createSection },
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      createSection: number =>
        dispatchProps.createSection(stateProps.section.board, number),
      moveSection: newNumber =>
        dispatchProps.moveSection(stateProps.section, newNumber),
      setSectionHeight: height =>
        dispatchProps.setSectionHeight(stateProps.section, height)
    })
  ),
  resizeSection,
  setPropTypes({
    sectionId: PropTypes.string.isRequired
  }),
  withTranslation()
)

const SectionContainer = ({ drag, ...props }) => (
  <DraggableCore onDrag={drag} handle={SectionResize.toString()}>
    {/* DraggableCore really want's a dom node */}
    <div
      style={{
        touchAction: 'initial' // override react-dragable hack that breaks android-chrome (https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278)
      }}
    >
      <Section {...props} />
    </div>
  </DraggableCore>
)

SectionContainer.propTypes = {
  drag: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired,
  editMode: PropTypes.bool.isRequired
}

export default enhance(SectionContainer)
